/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush on 7/9/20
 *
 */

//change to lazy loading

let YesNoDialog = () => import('@/core/components/Dialogs/YesNoDialog')
let YesNoCancelDialog = () => import('@/core/components/Dialogs/YesNoCancelDialog')
let DeleteItemConfirmDialog = () => import('@/core/components/Dialogs/DeleteItemConfirmDialog')
let DeleteConfirmDialog = () => import('@/core/components/Dialogs/QwoachDialog/DeleteConfirmDialog')
let CommandDialog = () => import('@/core/components/Dialogs/CommandDialog')
let MessageDialog = () => import('@/core/components/Dialogs/MessageDialog')
let TextInputDialog = () => import('@/core/components/Dialogs/ValueInputDialog/TextInputDialog.vue')
let DateInputDialog = () => import('@/core/components/Dialogs/ValueInputDialog/DateInputDialog.vue')
let ProgressDialog = () => import('@/core/components/Dialogs/ProgressDialog')
let ImageDialog = () => import('@/core/components/Dialogs/QwoachDialog/ImageDialog.vue')
let ShareLinkDialog = () => import('@/core/components/Dialogs/QwoachDialog/ShareLinkDialog.vue')
let QwImageEditDialog = () => import('@/core/components/Controls/QwImageUploader/QwImageEditDialog.vue')





// import YesNoDialog from '@/core/components/Dialogs/YesNoDialog'
// import YesNoCancelDialog from '@/core/components/Dialogs/YesNoCancelDialog'
// import DeleteItemConfirmDialog from '@/core/components/Dialogs/DeleteItemConfirmDialog'
// import DeleteConfirmDialog from '@/core/components/Dialogs/QwoachDialog/DeleteConfirmDialog'
// import CommandDialog from '@/core/components/Dialogs/CommandDialog'
// import MessageDialog from '@/core/components/Dialogs/MessageDialog'
// // import TextInputDialog from '@/core/components/Dialogs/TextInputDialog.vue'
// import ProgressDialog from '@/core/components/Dialogs/ProgressDialog'
// import ImageDialog from "@/core/components/Dialogs/QwoachDialog/ImageDialog.vue";
// import ShareLinkDialog from "@/core/components/Dialogs/QwoachDialog/ShareLinkDialog.vue";
import {createDialogLazy} from "@/utils/helpers-external.js";

export const Action = Object.freeze({
	OK: "actionOk",
	UPDATE: "actionUpdate",
	CANCEL: "actionCancel",
	CANCEL2: "actionCancel2",
	IMPORT: "actionImport",
	DELETE: "actionDelete",
	CONVERT: "actionConvert",
	RESCHEDULE: "actionReschedule",
	CANCEL_SESSION: "actionCancelSession",
	PICK: "actionPick",
})


export const yesNoCancelDialog = createDialogLazy(YesNoCancelDialog, 'title', 'description', 'yesTitle', 'noTitle', 'cancelTitle')
export const yesNoDialogOld = createDialogLazy(YesNoDialog, 'title', 'description', 'yesTitle', 'noTitle', 'rejectOnNo')
export const yesNoDialog = createDialogLazy(YesNoDialog)
export const commandDialog = createDialogLazy(CommandDialog, 'title', 'description', 'yesTitle', 'noTitle')
export const deleteConfirmDialogOld = createDialogLazy(DeleteItemConfirmDialog, 'itemName', 'additionalText', 'throwOnCancel')
export const deleteConfirmDialog = createDialogLazy(DeleteConfirmDialog)
export const messageDialogSimple = createDialogLazy(MessageDialog, 'title', 'message', 'buttonTitle')
export const messageDialog = createDialogLazy(MessageDialog)
export const textInputDialog = createDialogLazy(TextInputDialog)
export const dateInputDialog = createDialogLazy(DateInputDialog)
export const progressDialog = createDialogLazy(ProgressDialog)
export const imageDialog = createDialogLazy(ImageDialog)
export const shareLinkDialog = createDialogLazy(ShareLinkDialog)
export const imageEditDialog = createDialogLazy(QwImageEditDialog)


export const convertIntoActiveClientDialog = async (clientProfile) => {
	return yesNoDialog({
		title: "Convert into an active client",
		message2: `Are you sure you want to convert ${clientProfile.name} into an active client?<br/><br/>The client will be moved to the "Active clients" tab and they will be removed from this list.`,
		message: `Do you want to move ${clientProfile.name} to "Active clients" and remove them from potential clients?`,
		yesButton: "Convert",
		noButton: "Cancel",
	})
// <br/><br/><div class="text-muted">This will allow you to share resources with ${clientProfile.name}, send legal documents, schedule sessions, invite them to their personal secure portal and more.</div>`,

}
